<template>
    <div class="top-feature-box">
        <h3 class="mb-4" v-if="!isLoading && entry.top_features.length">{{$t('pds.top_equipment.title')}}</h3>

        <div class="row" v-if="!isLoading">
            <list-entry-column
                v-for="feature in entry.top_features"
                :key="feature.id"
                :value="$t('general.top_feature.' +feature.identifier)" icon="check"
            >
            </list-entry-column>
        </div>
        <div class="row" v-else>
            <list-entry-column-skeleton icon="check"></list-entry-column-skeleton>
            <list-entry-column-skeleton icon="check"></list-entry-column-skeleton>
            <list-entry-column-skeleton icon="check"></list-entry-column-skeleton>
            <list-entry-column-skeleton icon="check"></list-entry-column-skeleton>
        </div>
    </div>
</template>

<script>
import ListEntryColumn from "../atoms/ListEntryColumn.vue";
import ListEntryColumnSkeleton from "../atoms/ListEntryColumnSkeleton.vue";

export default {
    name: 'TopFeatureBox',
    components: {
        ListEntryColumn,
        ListEntryColumnSkeleton,
    },
    props: {
        entry: null,
        isLoading: true
    },
}
</script>
